import React from 'react';
import styled from 'styled-components';

import Button from '../global/button';
import Section from '../global/section';
import Top from '../top';
import mdToHtml from '../../util/mdToHtml';

const StyledContent = styled.div`
	section {
		padding: 0;
		& > div {
			padding: 0;
			max-width: none;
		}
	}
	.flex {
		display: flex;
		.left {
			width: 50%;
			padding: 4rem 2rem 4rem 2.5rem;
			background-color: #fff;
			.container {
				max-width: 600px;
				margin-left: auto;
			}
			h2 {
				margin-bottom: 1rem;
			}
		}
		.right {
			width: 50%;
			padding: 4rem 2.5rem 4rem 2rem;
			background-color: ${(p) => p.theme.color.light};
			.container {
				max-width: 600px;
				margin-right: auto;
			}
			h4 {
				color: ${(p) => p.theme.color.red};
				text-transform: uppercase;
				font-size: 1rem;
			}
			li {
				position: relative;
				margin-left: 1rem;
				&::before {
					content: '';
					background-color: ${(p) => p.theme.color.red};
					height: 7px;
					width: 7px;
					border-radius: 7px;
					position: absolute;
					left: -1rem;
					top: 4px;
				}
				&:last-child h4 {
					margin-left: -1rem;
					margin-top: 2rem;
					margin-bottom: -2rem;
				}
			}
			h3 {
				font-family: ${(p) => p.theme.fonts.heading};
				font-size: 1.2rem;
				margin: 1rem 0 0.25rem;
			}
		}
		@media all and (max-width: 768px) {
			flex-wrap: wrap;
			.left,
			.right {
				width: 100%;
				padding: 3rem 2.5rem;
				.container {
					max-width: none;
				}
			}
		}
		@media all and (max-width: 500px) {
			flex-wrap: wrap;
			.left,
			.right {
				padding: 2rem 1rem;
			}
		}
	}
`;

export default ({ data }) => {
	const { top, title, leftCopy, rightCopy, tier1, tier2 } = data;
	return (
		<StyledContent>
			<Section bg="white">
				<div className="flex">
					<div className="left">
						<div className="container">
							<Top color="blue">{top}</Top>
							<h2>{title}</h2>
							<div
								className="md-content"
								dangerouslySetInnerHTML={{
									__html: mdToHtml(leftCopy),
								}}
							/>
						</div>
					</div>
					<div className="right">
						<div className="container">
							<div
								className="md-content"
								dangerouslySetInnerHTML={{
									__html: mdToHtml(rightCopy),
								}}
							/>
							<h3>{tier1.title}</h3>
							<Button
								size="small"
								bg="blue"
								type="anchor"
								href={tier1.cta.link}
							>
								{tier1.cta.text}
							</Button>
							<h3>{tier2.title}</h3>
							<Button
								size="small"
								bg="blue"
								type="anchor"
								href={tier2.cta.link}
							>
								{tier2.cta.text}
							</Button>
						</div>
					</div>
				</div>
			</Section>
		</StyledContent>
	);
};
